module.exports = __webpack_public_path__ + "static/media/b1_p11_crystal.1453ef6f.mp3";